var _rect, _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAndroid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    rx: 14,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.8 14.2084C22.8 13.5584 22.7417 12.9334 22.6333 12.3334H14V15.8834H18.9333C18.7167 17.025 18.0667 17.9917 17.0917 18.6417V20.95H20.0667C21.8 19.35 22.8 17 22.8 14.2084Z",
    fill: "#4285F4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14 23.1667C16.475 23.1667 18.55 22.35 20.0667 20.95L17.0917 18.6417C16.275 19.1917 15.2333 19.525 14 19.525C11.6167 19.525 9.59165 17.9167 8.86665 15.75H5.81665V18.1167C7.32498 21.1083 10.4166 23.1667 14 23.1667Z",
    fill: "#34A853"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.86659 15.7417C8.68325 15.1917 8.57492 14.6084 8.57492 14.0001C8.57492 13.3917 8.68325 12.8084 8.86659 12.2584V9.89172H5.81659C5.19159 11.1251 4.83325 12.5167 4.83325 14.0001C4.83325 15.4834 5.19159 16.8751 5.81659 18.1084L8.19159 16.2584L8.86659 15.7417Z",
    fill: "#FBBC05"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14 8.48337C15.35 8.48337 16.55 8.95004 17.5083 9.85004L20.1333 7.22504C18.5417 5.74171 16.475 4.83337 14 4.83337C10.4166 4.83337 7.32498 6.89171 5.81665 9.89171L8.86665 12.2584C9.59165 10.0917 11.6167 8.48337 14 8.48337Z",
    fill: "#EA4335"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAndroid);
export default __webpack_public_path__ + "static/media/android.a79d85d913dbd6fe08cb1e7b76e2de4e.svg";
export { ForwardRef as ReactComponent };